<template>
  <v-navigation-drawer 
    app
    right
    fixed
    temporary
    touchless
    id="skinPerfil"
    class="sidebar"
    v-model="drawer"
    :width="width"
  >
    <v-container fill-height>

      <v-card 
        class="border-radius-2 py-4"
        color="#FFFFFFCC"
        elevation="0"
      >
        <v-row class="mx-4">
          <v-col cols="auto" class="mx-auto pa-0">
            <AvatarIcon :avatar="stUserAvatar" :height=75 :width=80 v-if="stUserAvatar"></AvatarIcon>
            <AvatarIcon :height=75 :width=80 v-else></AvatarIcon>
          </v-col>
          <v-col cols="12 pa-0">
            <p class="gretting mb-0">{{$t('home.greet')}}, <strong>{{ username }}!</strong></p>
          </v-col>
          <v-col cols="12" class="pt-1">
            <v-row>
              <v-col cols="6" class="d-flex justify-content-end pr-1">
                <div
                  class="font-weight-bold font-size-14 btn-awards"
                  color="white"
                  height="36"
                  small>
                    <v-img
                      :src="beecoins"
                      max-height="25"
                      max-width="25"
                    ></v-img>
                    <span class="btn-label ml-1">{{userBeecoin}}</span>
                </div>
              </v-col>
              <v-col cols="6" class="d-flex justify-content-start pl-1">
                <div
                  class="font-weight-bold font-size-14 btn-awards"
                  color="white"
                  height="36"
                  x-small>
                    <v-img
                      :src="xpIcon"
                      max-height="32"
                      max-width="32"
                    ></v-img>
                    <span class="btn-label ml-1">{{userPoints}}</span>
                </div>
              </v-col>
            </v-row>
            <!-- <template v-if="notifications.length">
              <v-badge
                color="#E86B59"
                dot
                offset-x="12"
                offset-y="15"
              >
                <v-btn elevation="0" class="btn-awards" :height="36" x-small>
                    <v-img
                      :src="notification"
                      max-height="25"
                      max-width="25"
                    ></v-img>
                </v-btn>
              </v-badge>
            </template>
            <template v-else>
              <v-btn elevation="0" class="btn-awards" :height="36" x-small>
                  <v-img
                    :src="notification"
                    max-height="25"
                    max-width="25"
                  ></v-img>
              </v-btn>
            </template> -->
          </v-col>
        <v-list data-cy="profile-perfil-item-list" class="perfil-menu w-100 text-left mt-2">
          <v-list-item to="/user/profile" class="px-2" data-cy="topBar-profile-btn">
            <v-row class="mx-0 px-0" align="center">
              <v-img :src="require('@/assets/img/icons/menu-perfil/icon-mi-perfil.svg')" max-height="25" max-width="25"></v-img>
              <span class="ml-2">
                {{ $t('home.my_profile') }}
              </span>
            </v-row>
          </v-list-item>
          <v-list-item data-cy="profile-books-item-list" to="/user/books" class="px-2">
            <v-row class="mx-0 px-0" align="center">
              <v-img :src="require('@/assets/img/icons/menu-perfil/icon-mis-libros.svg')" max-height="25" max-width="25"></v-img>
              <span class="ml-2">
                {{ $t('home.my_articles') }}
              </span>
            </v-row>
          </v-list-item>
          <v-list-item data-cy="profile-ranking-item-list" to="/user/ranking" class="px-2">
            <v-row class="mx-0 px-0" align="center">
              <v-img :src="require('@/assets/img/icons/menu-perfil/icon-ranking.svg')" max-height="25" max-width="25"></v-img>
              <span class="ml-2">
                {{ $t('home.ranking') }}
              </span>
            </v-row>
          </v-list-item>
          <v-list-item @click="logOut" class="px-2">
            <v-row class="mx-0 px-0" align="center">
              <v-img :src="require('@/assets/img/icons/menu-perfil/icon-salir.svg')" max-height="25" max-width="25"></v-img>
              <span class="ml-2">
                {{ $t('home.logout') }}
              </span>
            </v-row>
          </v-list-item>
        </v-list>
        </v-row>
      </v-card>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
import accessHistory from '@/services/accessHistory'
import UserSkinService from '../../services/userSkin'
import { mapState } from 'vuex'
import AvatarIcon from '../home/AvatarIcon.vue'
import global from '@/constants/GlobalConstant'

export default {
  components: {
    AvatarIcon
  },
  data() {
      return {
        drawer: null,
        group: null,
        loading: false,
        beecoins: require('@/assets/img/icons/beecoins.png'),
        xpIcon: require('@/assets/img/icons/xp-shadow.png'),
        treasure: require('@/assets/img/icons/treasure.png'),
        notification: require('@/assets/img/icons/notification.png'),
        skinDefault: require('@/assets/img/skins/skin-01.png'),
        beecoinsCount: 1600,
        notifications: []
      }
    },
    // props: ['book'],
    mounted() {
        this.$root.$on('profileDrawer', this.profileDrawer)
    },
    computed: {
      ...mapState({
        user: (state) => state.userData.user,
        existAssignedBook: (state) => state.userData.existAssignedBook,
        assignedBookId: (state) => state.userData.assignedBookId,
        messages: (state) => state.userData.recievedMessages,
        stUserAvatar: (state) => state.userData.avatarSelected,
        userBeecoin: (state) => state.userData.coins,
        userPoints: (state) => state.userData.points,
      }),
      username() {
        return this.setName(this.user)
      },
      showUsername() {
        return this.$router.currentRoute.path !== '/user/profile'
      },
      showUsernameAndInfo() {
        return this.$router.currentRoute.path !== '/user/store'
      },
      width() {
          if (this.$vuetify.breakpoint.xs) {
              return 320
          }
          if (this.$vuetify.breakpoint.sm) {
              return 360
          }
          if (this.$vuetify.breakpoint.lg) {
              return 380
          }
          if (this.$vuetify.breakpoint.xl) {
              return 400
          }
          return 380
      },
      imageW() {
        if (this.$vuetify.breakpoint.xs) {
            return 150
        }
        if (this.$vuetify.breakpoint.sm) {
            return 150
        }
        return 280
      }
    },
    methods: {
      profileDrawer() {
        this.drawer = !this.drawer
      },
      // siedebar
      reserve () {
        this.loading = true
        setTimeout(() => (this.loading = false), 2000)
      },
      setName(data) {
        return `${this.capitalizeText(data.firstname.split(' ')[0])} ${this.capitalizeText(
          data.lastname.split(' ')[0]
        )}`
      },
      capitalizeText(text) {
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
      },
      async logOut() {
          const vm = this
          this.$modal.confirm(
              'Confirmar',
              '¿Quieres cerrar tu sesión?',
              async () => {
                  await accessHistory.setLogout({ userId: this.user.id })
                      .then((response) => console.info(response))
                      .catch((error) => console.error(error));
                  vm.$store.dispatch('clearSession').then(() => {
                      setTimeout(() => {
                          window.location.href = process.env.VUE_APP_BEEREADERS_LOGIN_URL
                      }, 100)
                  })
              }
          )
      },
      setDesktop(skin) {
          const cardBanner = document.getElementById('skinPerfil')
          if (!skin) {
            cardBanner.style.backgroundImage = this.skinDefault
          }
          let img = skin.resources.find((res) => res.resourceUrl.includes('vertical'))
          if (!img) {
            img = skin.resources.find((res) => res.resourceUrl.includes('desktop'))
          }
          cardBanner.style.backgroundImage = `url("${this.$utils.globalConstants.BASE_ASSETS_URL}/skins/${img.resourceUrl}")`
        },
        getSelectedSkin() {
          UserSkinService.getSelectedByUser(this.user.id)
            .then((response) => {
              this.selectedSkin = response.content
              this.setDesktop(response.content)
            })
            .catch((error) => console.error(error))
      },
    },
    created() {
      this.getSelectedSkin()
    },
    watch: {
      existAssignedBook(newValue) {
        if (newValue && this.notifications[0]) {
          this.notifications[0].show = true
          this.notifications[0].to = `/user/book/${this.assignedBookId}`
        }
      },
      group () {
        this.drawer = false
      },
    },
}
</script>

<style lang="scss" scoped>
.gretting{
  font-size: 1.2em;
}
.perfil-menu{
  background: #FFFFFFCC;
  color: #323A46;
  font-weight: 600;
}
.sidebar{
  background-size: cover;
}
</style>